// extracted by mini-css-extract-plugin
export var content = "s-module--content--891c1";
export var contentDescription = "s-module--contentDescription--cd9f7";
export var ctaBlock = "s-module--ctaBlock--e85d4";
export var ctaBlockWrapper = "s-module--ctaBlockWrapper--e703d";
export var title = "s-module--title--99d21";